// Constants
import { MEASUREMENT_REMOVE, MEASUREMENT_SET } from './elementMeasurements/elementMeasurementsConstants';
import { POI_REMOVE, POI_SET } from '../pointsOfInterest/poiConstants';

export const MEASUREMENTS_STORE_NAME = 'measurementsStore';

export const BULK_MEASUREMENT_ACTIONS = [MEASUREMENT_SET, MEASUREMENT_REMOVE, POI_SET, POI_REMOVE];
